import { render } from "./PRCarousel.vue?vue&type=template&id=a590befa&ts=true&lang=pug"
import script from "./PRCarousel.vue?vue&type=script&lang=ts"
export * from "./PRCarousel.vue?vue&type=script&lang=ts"

import "./PRCarousel.vue?vue&type=style&index=0&id=a590befa&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__